'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isComposable = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _unset2 = require('lodash/unset');

var _unset3 = _interopRequireDefault(_unset2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _set2 = require('lodash/set');

var _set3 = _interopRequireDefault(_set2);

exports.default = queriesReducer;

var _immer = require('immer');

var _immer2 = _interopRequireDefault(_immer);

var _constants = require('../constants');

var _query = require('../utils/query');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isComposable = exports.isComposable = function isComposable(action) {
  return (0, _get3.default)(action, 'meta.where') && (0, _get3.default)(action, 'meta.collection');
};

function queriesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  return (0, _immer2.default)(state, function (draft) {
    if (!isComposable(action)) {
      return state;
    }

    var key = (0, _query.getBaseQueryName)(action.meta);

    switch (action.type) {
      case _constants.actionTypes.GET_SUCCESS:
      case _constants.actionTypes.LISTENER_RESPONSE:
        draft[key] = (0, _extends3.default)({ data: action.payload.data }, action.meta);
        return draft;
      case _constants.actionTypes.UNSET_LISTENER:
        if (draft[key]) {
          draft[key].data = undefined;
        }

        return draft;
      case _constants.actionTypes.DOCUMENT_ADDED:
      case _constants.actionTypes.DOCUMENT_MODIFIED:
        (0, _set3.default)(draft, [key, 'data', action.meta.doc], action.payload.data);
        return draft;
      case _constants.actionTypes.DOCUMENT_REMOVED:
      case _constants.actionTypes.DELETE_SUCCESS:
        (0, _unset3.default)(draft, [key, 'data', action.meta.doc]);
        return draft;
      default:
        return state;
    }
  });
}